import { ScreenWidth } from 'web-common/src/shared/styles';

export const maxScreen = (screenWidth: ScreenWidth) => `@media (max-width: ${screenWidth})`;

export const minScreen = (screenWidth: ScreenWidth) => `@media (min-width: ${screenWidth})`;

export const minMaxScreen = ({ min, max }: { min: ScreenWidth; max: ScreenWidth }) =>
  `@media (min-width: ${min}) and (max-width: ${max})`;
